module.exports = __webpack_public_path__ + "img/slider_galery_21.8cd995dd.jpg";